/* ------------------------------------------------------
 * 初期化処理
 * ------------------------------------------------------ */
const $ = jQuery;
$(function () {
  AOS.init({
    duration: 1000,
  });

  // close offcanvas menu, scroll
  const closeButton = document.getElementsByClassName('btn-close')[0];
  $('#main-menu > li > a[href^="/#"]').click(function (e) {
    if ($('body').hasClass('home')) {
      e.preventDefault();
      const elmHash = $(this).attr('href').replace('/', '');
      const pos = $(elmHash).offset().top - 80;
      closeButton.click();
      window.scrollTo(0, pos);
    }
  });

  // collapse icon animation
  const togglers = document.querySelectorAll('.collapse-toggler');
  togglers.forEach(function (toggler) {
    const icon = toggler.querySelector('i');

    toggler.addEventListener('click', function () {
      console.log('click');
      icon.classList.toggle('transform');
      if (icon.classList.contains('bi-plus-lg')) {
        icon.classList.remove('bi-plus-lg');
        icon.classList.add('bi-dash-lg');
      } else {
        icon.classList.remove('bi-dash-lg');
        icon.classList.add('bi-plus-lg');
      }
    });
  });
});
